/**
 * Custom error class for booking errors.
 */
export class BookingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'BookingError';
  }
}
/**
 * @desc
 * Custom error class for job lock  errors.
 * Mostly used for HTTP 409 errors.
 */
export class JobLockError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'JobLockError';
  }
}
/**
 * @desc
 * Custom error class for job lock by user errors.
 * Mostly used for HTTP 403 errors.
 */
export class JobLockByUserError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'JobLockByUserError';
  }
}

/**
 * @desc
 * Custom error class for validation errors.
 * Mostly used for HTTP 400 errors.
 */
export class ValidationAPIError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationAPIError';
  }
}

/**
 * @desc
 * Custom error class for **handled** Scheduler errors.
 * Mostly used for HTTP 400 errors.
 */
export class HandledBoardAPIError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'HandledBoardAPIError';
  }
}

/**
 * @desc
 * Custom error class for stop conflicts in the scheduler board.
 * Used when stops with the same rh_id are on the board and in unscheduled stops.
 */
export class StopConflictError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'StopConflictError';
  }
}

export class LoadingLinkedQuantsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LoadingLinkedQuantsError';
  }
}
